import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';
import { AnEvent, Draw, Match, Player } from '../Main.Model';

@Component({
    selector: 'app-score-edit',
    templateUrl: './score-edit.component.html',
    styleUrls: ['./score-edit.component.css'],
    standalone: false
})
export class ScoreEditComponent implements OnInit {

  @Input('SelectedMatch') public SelectedMatch!: Match;
  datePipe = new DatePipe('en-US');
  //@Input('isEditingMatchScore') public isEditingMatchScore: boolean;

  constructor(private FunctionService: FunctionService, public DataService: DataService, private APIService: APIService) { }

  ngOnInit(): void {
    this.DataService.SelectedMatch.formatedDateOfMatch = this.datePipe.transform(this.DataService.SelectedMatch.dateOfMatch, 'yyyy-MM-ddTHH:mm:ss')!;
  }

  NoTennis(match: Match) {
    match.noTennis = true;
  }

  WalkOver(playerNumber: number) {
    if (this.DataService.SelectedMatch.woWinner == 0) {
      this.DataService.SelectedMatch.woWinner = playerNumber;
    } else {
        this.DataService.SelectedMatch.woWinner = 0;
    }
    this.FunctionService.updateNeedsToWin(this.DataService.SelectedMatch);
  }

  EditScoreKeyPress(event: KeyboardEvent) {
    if (event.key === "Tab") {
        if (this.DataService.SelectedMatch.ttScore1 > 0 && this.DataService.SelectedMatch.ttScore1 < 21) {
            this.DataService.SelectedMatch.ttScore2 = 21
        }
        if (this.DataService.SelectedMatch.ttScore2 > 0 && this.DataService.SelectedMatch.ttScore2 < 21) {
            this.DataService.SelectedMatch.ttScore1 = 21
        }
        if (this.DataService.SelectedMatch.badScore1 > 0 && this.DataService.SelectedMatch.badScore1 < 21) {
            this.DataService.SelectedMatch.badScore2 = 21
        }
        if (this.DataService.SelectedMatch.badScore2 > 0 && this.DataService.SelectedMatch.badScore2 < 21) {
            this.DataService.SelectedMatch.badScore1 = 21
        }
        if (this.DataService.SelectedMatch.squashScore1 > 0 && this.DataService.SelectedMatch.squashScore1 < 21) {
            this.DataService.SelectedMatch.squashScore2 = 21
        }
        if (this.DataService.SelectedMatch.squashScore2 > 0 && this.DataService.SelectedMatch.squashScore2 < 21) {
            this.DataService.SelectedMatch.squashScore1 = 21
        }
        if (this.DataService.SelectedMatch.tScore1 > 0 && this.DataService.SelectedMatch.tScore1 < 21) {
            this.DataService.SelectedMatch.tScore2 = 21
        }
        if (this.DataService.SelectedMatch.tScore2 > 0 && this.DataService.SelectedMatch.tScore2 < 21) {
            this.DataService.SelectedMatch.tScore1 = 21
        }
    }
    this.FunctionService.calculateScores(this.DataService.SelectedMatch);
  }

  saveMatchScore() {
    this.FunctionService.calculateScores(this.DataService.SelectedMatch);
    this.FunctionService.UpdateWinnerOfMatch(this.DataService.SelectedMatch);
    this.APIService.updateMatch(this.DataService.SelectedMatch);
    //need to now add player names to their next round if the match is complete and not a final...
    this.FunctionService.assignPlayersToNextRound(this.DataService.SelectedDraw, this.DataService.SelectedMatch);
    this.DataService.SelectedMatch = undefined as any;
    this.DataService.isEditingMatchScore = false;
    this.FunctionService.recreatePlacings();
  }

  scoreKeydown(TheEvent: KeyboardEvent) {
    if (TheEvent.key === "Tab") {
      if (this.DataService.SelectedMatch.ttScore1 > 0 && this.DataService.SelectedMatch.ttScore1 < 21) {
          this.DataService.SelectedMatch.ttScore2 = 21
      }
      if (this.DataService.SelectedMatch.ttScore2 > 0 && this.DataService.SelectedMatch.ttScore2 < 21) {
          this.DataService.SelectedMatch.ttScore1 = 21
      }
      if (this.DataService.SelectedMatch.badScore1 > 0 && this.DataService.SelectedMatch.badScore1 < 21) {
          this.DataService.SelectedMatch.badScore2 = 21
      }
      if (this.DataService.SelectedMatch.badScore2 > 0 && this.DataService.SelectedMatch.badScore2 < 21) {
          this.DataService.SelectedMatch.badScore1 = 21
      }
      if (this.DataService.SelectedMatch.squashScore1 > 0 && this.DataService.SelectedMatch.squashScore1 < 21) {
          this.DataService.SelectedMatch.squashScore2 = 21
      }
      if (this.DataService.SelectedMatch.squashScore2 > 0 && this.DataService.SelectedMatch.squashScore2 < 21) {
          this.DataService.SelectedMatch.squashScore1 = 21
      }
      if (this.DataService.SelectedMatch.tScore1 > 0 && this.DataService.SelectedMatch.tScore1 < 21) {
          this.DataService.SelectedMatch.tScore2 = 21
      }
      if (this.DataService.SelectedMatch.tScore2 > 0 && this.DataService.SelectedMatch.tScore2 < 21) {
          this.DataService.SelectedMatch.tScore1 = 21
      }
  } else if (TheEvent.key === "ArrowDown") {
      switch ((TheEvent.currentTarget as HTMLInputElement)?.id) {
          case 'TT1':
            TheEvent.preventDefault();
              var TT2 = document.getElementById('TT2')!;
              TT2.focus();
              break;
          case 'Bad1':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Bad2')!;
              Bad2.focus();
              break;
          case 'Squash1':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('Squash2')!;
              Squash2.focus();
              break;
          case 'T1':
              TheEvent.preventDefault();
              var T2 = document.getElementById('T2')!;
              T2.focus();
              break;
          case 'TT2':
              TheEvent.preventDefault();
          case 'Bad2':
              TheEvent.preventDefault();
          case 'Squash2':
              TheEvent.preventDefault();
          case 'T2':
              TheEvent.preventDefault();
      }
  } else if (TheEvent.key === "ArrowUp") {
      switch ((TheEvent.currentTarget as HTMLInputElement)?.id) {
          case 'TT2':
              TheEvent.preventDefault();
              var TT2 = document.getElementById('TT1')!;
              TT2.focus();
              break;
          case 'Bad2':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Bad1')!;
              Bad2.focus();
              break;
          case 'Squash2':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('Squash1')!;
              Squash2.focus();
              break;
          case 'T2':
              TheEvent.preventDefault();
              var T1 = document.getElementById('T1')!;
              T1.focus();
              break;
          case 'TT1':
              TheEvent.preventDefault();
          case 'Bad1':
              TheEvent.preventDefault();
          case 'Squash1':
              TheEvent.preventDefault();
          case 'T1':
              TheEvent.preventDefault();
      }
  } else if (TheEvent.key === "ArrowLeft") {
      switch ((TheEvent.currentTarget as HTMLInputElement)?.id) {
          case 'TT1':
              TheEvent.preventDefault();
              break;
          case 'Bad1':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('TT1')!;
              Bad2.focus();
              break;
          case 'Squash1':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('Bad1')!;
              Squash2.focus();
              break;
          case 'T1':
              TheEvent.preventDefault();
              var T2 = document.getElementById('Squash1')!;
              T2.focus();
              break;
          case 'TT2':
              TheEvent.preventDefault();
              break;
          case 'Bad2':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('TT2')!;
              Bad2.focus();
              break;
          case 'Squash2':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('Bad2')!;
              Squash2.focus();
              break;
          case 'T2':
              TheEvent.preventDefault();
              var T1 = document.getElementById('Squash2')!;
              T1.focus();
              break;
      }
  } else if (TheEvent.key === "ArrowRight") {
      switch ((TheEvent.currentTarget as HTMLInputElement)?.id) {
          case 'TT1':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Bad1')!;
              Bad2.focus();
              break;
          case 'Bad1':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Squash1')!;
              Bad2.focus();
              break;
          case 'Squash1':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('T1')!;
              Squash2.focus();
              break;
          case 'T1':
              TheEvent.preventDefault();
              break;
          case 'TT2':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Bad2')!;
              Bad2.focus();
              break;
          case 'Bad2':
              TheEvent.preventDefault();
              var Bad2 = document.getElementById('Squash2')!;
              Bad2.focus();
              break;
          case 'Squash2':
              TheEvent.preventDefault();
              var Squash2 = document.getElementById('T2')!;
              Squash2.focus();
              break;
          case 'T2':
              TheEvent.preventDefault();
              break;
      }
  }
  this.FunctionService.updateNeedsToWin(this.DataService.SelectedMatch);
  }

//   Submit() { 
//     if (this.DataService.SelectedTorn.endDateOfEvent > this.FunctionService.Today || this.DataService.LoggedInUser.accessLevel > 2 || this.DataService.SelectedTorn.directorId == this.DataService.LoggedInUser.id) {//anyone can edit until 2 days afetr event
//       this.DataService.SelectedMatch.duration = this.FunctionService.getDateDiff(new Date(), this.DataService.SelectedMatch.dateOfMatch, 'mins');
//         this.APIService.updateMatch(this.DataService.SelectedMatch);
//         //update draw
//         var TheWinner = this.FunctionService.findWinner(this.DataService.SelectedMatch);

//         if (this.DataService.SelectedDraw.format === "KO") {
//           var ScoreLabel = document.getElementById("KOScore" + this.DataService.SelectedMatch.matchNo);
//             this.FunctionService.showScore(this.DataService.SelectedMatch, ScoreLabel, this.DataService.SelectedMatch.player1Name);
//             if (!TheWinner) {
//                 //var ScoreLabel = document.getElementById("KOScore" + this.DataService.SelectedMatch.matchNo);
//                 //this.FunctionService.showScore(this.DataService.SelectedMatch, ScoreLabel, this.DataService.SelectedMatch.player1Name);
//                 this.DataService.SelectedMatch = null;
//                 return;
//             }
//             var player1Or2 = 0;
//             var NextMatch = 0;
//             var NextMatchForLoser = 0;
//             if (this.DataService.SelectedMatch.matchNo < 3) {
//                 NextMatch = 5;
//                 NextMatchForLoser = 8;
//                 player1Or2 = this.DataService.SelectedMatch.matchNo;
//             } else if (this.DataService.SelectedMatch.matchNo < 5) {
//                 NextMatch = 6;
//                 NextMatchForLoser = 9;
//                 player1Or2 = this.DataService.SelectedMatch.matchNo - 2;
//             } else if (this.DataService.SelectedMatch.matchNo < 7) {
//                 if (this.DataService.SelectedDraw.KO4Player == true) {
//                     NextMatch = 7;//was final but
//                     NextMatchForLoser = 0;
//                     player1Or2 = 1;
//                 } else {
//                     NextMatch = 7;
//                     NextMatchForLoser = 11;
//                     player1Or2 = this.DataService.SelectedMatch.matchNo - 4;
//                 }
//             } else if (this.DataService.SelectedMatch.matchNo === 7) {
//                 NextMatch = 0;//was final
//             } else if (this.DataService.SelectedMatch.matchNo < 10) {
//                 if (this.DataService.SelectedDraw.KO4Player == true) {
//                     NextMatch = 10;//was final
//                     NextMatchForLoser = 0;
//                     player1Or2 = 1;
//                 } else {
//                     NextMatch = 10;
//                     NextMatchForLoser = 12;
//                     player1Or2 = this.DataService.SelectedMatch.matchNo - 7;
//                 }
//             } else if (this.DataService.SelectedMatch.matchNo === 10) {
//                 NextMatch = 0;//was plate final
//             } else if (this.DataService.SelectedMatch.matchNo === 11) {
//                 NextMatch = 0;//was sp plate final
//             } else if (this.DataService.SelectedMatch.matchNo === 12) {
//                 NextMatch = 0;//was cons plate final
//             }
//             //add winner & Loser to next matches?
//             if (NextMatch > 0 && player1Or2 == 1) {
//                 this.DataService.SelectedDraw.Matches[NextMatch - 1].player1 = TheWinner.id;
//                 this.DataService.SelectedDraw.Matches[NextMatch - 1].player1Name = TheWinner.name;
//                 this.FunctionService.assignPlayersToMatch(NextMatch, TheWinner, null)
//                 if (NextMatchForLoser > 0) {
//                     this.DataService.SelectedDraw.Matches[NextMatchForLoser - 1].player1 = this.DataService.Loser.id;
//                     this.DataService.SelectedDraw.Matches[NextMatchForLoser - 1].player1Name = this.DataService.Loser.name;
//                     this.FunctionService.assignPlayersToMatch(NextMatchForLoser, this.DataService.Loser, null)
//                 }
//             } else if (NextMatch > 0 && player1Or2 == 2) {
//                 this.DataService.SelectedDraw.Matches[NextMatch - 1].player2 = TheWinner.id;
//                 this.DataService.SelectedDraw.Matches[NextMatch - 1].player2Name = TheWinner.name;
//                 this.DataService.SelectedDraw.Matches[NextMatchForLoser - 1].player2 = this.DataService.Loser.id;
//                 this.DataService.SelectedDraw.Matches[NextMatchForLoser - 1].player2Name = this.DataService.Loser.name;
//                 this.FunctionService.assignPlayersToMatch(NextMatch, null, TheWinner)
//                 this.FunctionService.assignPlayersToMatch(NextMatchForLoser, null, this.DataService.Loser)
//             }
//             //this.FunctionService.updateKO4PlayerCheckBox();
//             //this.FunctionService.checkForNewMatchPosibilites();//check to see if any matches can be created....
//         } else if (this.DataService.SelectedDraw.format === "RR" && this.DataService.SelectedMatch.subDrawNumber < 3) {
//             //just show the score in both labels: 

//             var TableBody = document.getElementById("TableBody" + this.DataService.SelectedMatch.subDrawNumber);
//             var TheRow = TableBody.getElementsByTagName('tr')[this.DataService.SelectedRowIndex - 1];
//             var cellSelected = TheRow.getElementsByTagName('td')[this.DataService.SelectedColumnIndex];
//             //var matchScoreLabel = document.getElementById("R" + this.DataService.SelectedMatch.subDrawNumber + "RScore" + this.DataService.SelectedMatch.matchNo);
//             var NameOnLabel = TheRow.getElementsByTagName('td')[1].innerHTML;

//             this.FunctionService.showScore(this.DataService.SelectedMatch, cellSelected, NameOnLabel);//first show score in 1 cell
//             TheRow = TableBody.getElementsByTagName('tr')[this.DataService.SelectedColumnIndex - 2];
//             cellSelected = TheRow.getElementsByTagName('td')[this.DataService.SelectedRowIndex + 1];
//             NameOnLabel = TheRow.getElementsByTagName('td')[1].innerHTML;
//             this.FunctionService.showScore(this.DataService.SelectedMatch, cellSelected, NameOnLabel);//then the other
//             this.FunctionService.recreatePlacings();
//             this.FunctionService.FillRRPlayOffs();
//             //this.workOutRoundRobinPlayOffMatches();
//         } else if (this.DataService.SelectedMatch.subDrawNumber == 3) {//RR playoffs
//             var TheLabel = document.getElementById("RRPOW" + (this.DataService.SelectedMatch.matchNo - this.DataService.NormalLimit));
//             this.FunctionService.showScore(this.DataService.SelectedMatch, TheLabel, TheWinner.name);
//         } else {//Extra matches
//             //var matchLabel = document.getElementById("EMW" + this.DataService.SelectedMatch.matchNo);
//             //if (TheWinner) {
//             //    matchLabel.innerHTML = TheWinner.name;
//             //}
//             ////and show the score:
//             //var matchScoreLabel = document.getElementById("EMS" + this.DataService.SelectedMatch.matchNo);
//             //this.showScore(this.DataService.SelectedMatch, matchScoreLabel, "");
//             //this.updateTheWinners(this.DataService.SelectedMatch);
//         }
//         //}
//         this.FunctionService.UpdateMatchWinners(this.DataService.SelectedDraw);
//         this.DataService.SelectedLabelIndex = 0;
//         this.DataService.SaveState();
//     } else {
//         alert("Only the Tournament Director can update scores after 48 hours from the start of the tournament");
//     }
//     this.DataService.SelectedMatch = null;//hides modal enter score window
//   }

  close() {
    this.DataService.SelectedMatch = undefined as any;
  }

}
